import { isNotNil } from '@flowio/is';
var isBrowser = typeof window !== 'undefined' && isNotNil(window.document) && isNotNil(window.document.createElement);
export default isBrowser;
//# sourceMappingURL=isBrowser.js.map